import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78e980e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 2,
  class: "entity-text"
}
const _hoisted_3 = {
  key: 1,
  class: "normal-text"
}
const _hoisted_4 = {
  key: 2,
  class: "icon has-text-warning has-tooltip-bottom",
  "data-tooltip": "This entity exceeds the parent's text length"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warning" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Token = _resolveComponent("Token", true)!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.entity)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "entity",
          style: _normalizeStyle(_ctx.entityStyle(_ctx.entity.type)),
          to: { name: 'entity-details', params: { id: _ctx.entity.id } }
        }, {
          default: _withCtx(() => [
            (_ctx.displayEntityTypes)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "entity-type",
                  style: _normalizeStyle(_ctx.tagStyle(_ctx.entity.type)),
                  title: `${_ctx.entity.type.name} - ${_ctx.entity.name}`
                }, _toDisplayString(_ctx.entity.type.name), 13, _hoisted_1))
              : _createCommentVNode("", true),
            (_ctx.tokens.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tokens, (token, index) => {
                  return (_openBlock(), _createBlock(_component_Token, _mergeProps(token, { key: index }), null, 16))
                }), 128))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.text), 1))
          ]),
          _: 1
        }, 8, ["style", "to"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1)),
    (_ctx.overflow)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}